import * as React from "react";
import Privacy from "src/pages/Privacy";
import Layout from "@components/Layout";
import Head from "next/head";

const Index = () => {
  return (
    <Layout>
      <Head>
        <title>Inawo | Privacy</title>
        <meta
          name="description"
          content="Read the Inawo privacy policy to understand how we collect, use, and protect personal information for couples, guests, and vendors."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <Privacy />
    </Layout>
  );
};

export default Index;
